import React, { memo } from 'react';

const LoadingSpinner = memo(({ darkMode }) => (
  <div className="flex justify-center items-center py-12">
    <div className={`animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 ${
      darkMode ? 'border-blue-400' : 'border-blue-600'
    }`}></div>
  </div>
));

export default LoadingSpinner;
